/* CBH — FAQ #4 (accordion + search + deep links + copy links) */
(() => {
  const ROOT_SEL = '[data-cbh-faq]';

  function toText(el) {
    return (el?.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function getHashId() {
    const h = window.location.hash || '';
    if (!h.startsWith('#faq-')) return null;
    return h.slice(1);
  }

  function initOne(root) {
    if (!root || root.dataset.cbhFaqInit === '1') return;
    root.dataset.cbhFaqInit = '1';

    const oneOpen = root.getAttribute('data-one-open') === 'true';
    const allowCopy = root.getAttribute('data-copy-links') === 'true';

    const items = Array.from(root.querySelectorAll('[data-cbh-faq-item]'));
    const search = root.querySelector('[data-cbh-faq-search]');
    const empty = root.querySelector('[data-cbh-faq-empty]');

    // One-open behaviour (close siblings)
    if (oneOpen) {
      items.forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          items.forEach((other) => {
            if (other !== details) other.removeAttribute('open');
          });
        });
      });
    }

    // Deep-link open on load
    const openFromHash = () => {
      const id = getHashId();
      if (!id) return;

      const summary = root.querySelector(`#${CSS.escape(id)}`);
      if (!summary) return;

      const details = summary.closest('details');
      if (!details) return;

      details.setAttribute('open', '');
      // Small delay helps when content-visibility is enabled
      setTimeout(() => {
        summary.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, 50);
    };

    openFromHash();
    window.addEventListener('hashchange', openFromHash);

    // Search filter
    if (search) {
      const run = () => {
        const q = (search.value || '').trim().toLowerCase();
        let shown = 0;

        items.forEach((details) => {
          const summary = details.querySelector('summary');
          const answer = details.querySelector('[data-cbh-faq-a]');
          const hay = (toText(summary) + ' ' + toText(answer));

          const match = !q || hay.includes(q);
          details.closest('.cbh-faq__cell')?.toggleAttribute('hidden', !match);
          if (match) shown++;
        });

        if (empty) empty.hidden = shown !== 0;
      };

      search.addEventListener('input', run);
      run();
    }

    // Copy link buttons (optional)
    if (allowCopy) {
      root.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-cbh-faq-copy]');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation(); // don’t toggle the accordion accidentally

        const summary = btn.closest('summary');
        if (!summary || !summary.id) return;

        const url = `${window.location.origin}${window.location.pathname}${window.location.search}#${summary.id}`;

        try {
          await navigator.clipboard.writeText(url);
          btn.textContent = 'Copied';
          setTimeout(() => (btn.textContent = 'Link'), 900);
        } catch (_) {
          // Fallback
          const ta = document.createElement('textarea');
          ta.value = url;
          ta.setAttribute('readonly', '');
          ta.style.position = 'absolute';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          btn.textContent = 'Copied';
          setTimeout(() => (btn.textContent = 'Link'), 900);
        }
      });
    }
  }

  function boot(scope = document) {
    scope.querySelectorAll(ROOT_SEL).forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
